/**
 * @desc 发布预告公告
 */
import { AnnouncementBatchForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type BatchPublishAnnouncementParameter = AnnouncementBatchForm

const method = 'PUT'
const url = '/trade/operation/announcement/batch/public'

export const batchPublishAnnouncementApi = (
  data?: BatchPublishAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

batchPublishAnnouncementApi.method = method
batchPublishAnnouncementApi.url = url
